import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { useContactModal } from './ContactModalContext';
import rp_swiss from '../img/rp_swiss_small.png';
import no_user from '../img/no_user.png';
import AuthSocialForm from './AuthSocialForm';
import UserPoller, { useUserPoller } from './UserPoller';




export default function Nav() {
  const { strings, setLang, lang } = useLanguage();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { showContact, openContact, closeContact } = useContactModal();
  const [showLoginAndRegistration, setshowLoginAndRegistration] = useState(false);

 
 
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const nameRef = useRef(null);
  const emailRef = useRef(null);

  const [isLogin, setIsLogin] = useState(true);

  
  



 
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') closeContact();
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  useEffect(() => {
    if (showContact) {
      setTimeout(() => nameRef.current && nameRef.current.focus(), 50);
    } else {
      setName('');
      setEmail('');
      setMessage('');
      setSending(false);
      setSent(false);
    }
  }, [showContact]);

  useEffect(() => {
    if (showLoginAndRegistration) {
      setTimeout(() => nameRef.current && nameRef.current.focus(), 50);
    } else {
     
    }
  }, [showLoginAndRegistration]);
  


  const sendEmail = async (e) => {
                    try{
                      const resp = await fetch(process.env.REACT_APP_EMAIL_ENDPOINT, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        email: e.target.user_email.value,
                        name:  e.target.user_name.value,
                        message: e.target.message.value,
                        subject: strings.contactForm.mailSubject
                      }),
                      });
                      const data = await resp.json();
                      console.log(data);
                  } catch (error) {
                      console.error('Error sending email:', error);
                  }
  }  

  // Start the user poller and get a single `user` state for this Nav
  const { user, loading: userLoading, error: userError } = 
  useUserPoller();



  window.addEventListener('message', 
    (event) => {   
       if (event.data === 'auth-success') 
        {  
          console.log("Authentication successful");    
          window.location.reload();  
        }  
    });




  return (
  
    <header className="site-nav">
      <div className="nav-inner">
        <div className="nav-left"><a href="/"><img src={rp_swiss} alt={strings.nav.logo}/></a></div>

        <nav className="nav-right" aria-label="Primary">
          <NavLink to="/register" className={({ isActive }) => isActive ? 'btn-cta active' : 'btn-cta'}>
            {strings.nav.register}
          </NavLink>
          <NavLink to="/register_professional" className={({ isActive }) => isActive ? 'btn-cta active' : 'btn-cta'}>
            {strings.nav.register_professional}
          </NavLink>  
          {/*           
          <NavLink to="/events" className={({ isActive }) => isActive ? 'btn-cta active' : 'btn-cta'}>
            {strings.nav.events}
          </NavLink>
          */}
        
        </nav>

        {/* Hamburger for mobile */}
        <button className="hamburger" aria-label={mobileOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileOpen} onClick={() => setMobileOpen(!mobileOpen)}>
          <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3 6h18M3 12h18M3 18h18" stroke="#ada8a8ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>

        {mobileOpen && (
          <div className="mobile-menu" role="dialog" aria-modal="false">
            <button className="mobile-close" onClick={() => setMobileOpen(false)} aria-label="Close menu">×</button>
            <nav className="mobile-nav">
              <NavLink to="/register" onClick={() => setMobileOpen(false)}>{strings.nav.register}</NavLink>
               <NavLink to="/register_professional" onClick={() => setMobileOpen(false)}>{strings.nav.register_professional}</NavLink>
               {/*<NavLink to="/events" onClick={() => setMobileOpen(false)}>{strings.nav.events}</NavLink>*/}
            </nav>
          </div>
        )}

        <div className="nav-tools" aria-hidden={false}>
          <div className="nav-contact" aria-label="Contact links">
            <button className="icon" type="button" onClick={() => openContact()} aria-label={strings.contact.emailAria} title={strings.contact.emailAria}>
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1 .9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="#fff"/></svg>
            </button>
            <a className="icon" href={process.env.REACT_APP_TEL} target="_new" aria-label={strings.contact.phoneAria} title={strings.contact.phoneAria} >
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 01.9-.27 11.36 11.36 0 003.58.57 1 1 0 011 1v3.5a1 1 0 01-1 1A16 16 0 013 5a1 1 0 011-1h3.5a1 1 0 011 1 11.36 11.36 0 00.57 3.58 1 1 0 01-.27.9l-2.18 2.31z" fill="#fff"/></svg>
            </a>
            {/*}
            <a className="icon" href={strings.social_media.linkedin} target="_new" aria-label={strings.contact.linkedinAria} title={strings.contact.linkedinAria}>
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zM8.54 18V10.5H6.23V18H8.54zM7.39 9.4a1.4 1.4 0 11.001-2.801A1.4 1.4 0 017.39 9.4zM18 18v-4.5a2 2 0 00-2-2 2 2 0 00-2 2V18h2.3v-4.1c0-1 .7-1.3 1-1.3s1 .3 1 1.3V18H18z" fill="#fff"/></svg>
            </a>
            */}
            <a className="icon" href={strings.social_media.instagram} target="_new" aria-label={strings.contact.instagramAria} title={strings.contact.instagramAria} >
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 6.2A4.8 4.8 0 1016.8 13 4.8 4.8 0 0012 8.2zm5.2-3.4a1.12 1.12 0 11-1.12 1.12A1.12 1.12 0 0117.2 4.8zM12 10.4A1.6 1.6 0 1110.4 8.8 1.6 1.6 0 0112 10.4z" fill="#fff"/></svg>
            </a>
            <a className="icon" href={process.env.REACT_APP_WATSAPP} target="_new" aria-label={strings.contact.whatsappAria} title={strings.contact.whatsappAria}>
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M20.52 3.48A11.94 11.94 0 0012 0C5.37 0 .01 5.36.01 12a11.8 11.8 0 001.7 6l-1 4 4-1A11.94 11.94 0 0012 24c6.63 0 12-5.36 12-12 0-3.2-1.24-6.21-3.48-8.52zM12 21.5c-2.06 0-4-.57-5.7-1.56l-.4-.24-2.74.7.73-2.67-.26-.43A9.5 9.5 0 012.5 12 9.5 9.5 0 0112 2.5 9.5 9.5 0 0121.5 12 9.5 9.5 0 0112 21.5zM17.28 14.3c-.26-.13-1.54-.76-1.78-.85-.24-.09-.41-.13-.58.13s-.66.85-.8 1.03c-.14.17-.28.2-.52.07-.24-.13-1.02-.37-1.94-1.19-.72-.64-1.2-1.44-1.34-1.68-.14-.24-.02-.37.11-.5.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.58-1.4-.8-1.9-.21-.5-.43-.43-.58-.44l-.5-.01c-.17 0-.43.06-.66.3-.23.24-.88.86-.88 2.09s.9 2.42 1.02 2.59c.12.17 1.78 2.78 4.32 3.9 3.04 1.4 3.29 1.12 3.89 1.05.6-.07 1.95-.79 2.23-1.56.28-.77.28-1.43.2-1.56-.08-.13-.24-.2-.5-.33z" fill="#fff"/></svg>
            </a>
            {/*
            {
             user ?
            <button className="icon" onClick={() => window.location.href = process.env.REACT_APP_BASE_SERVER_URL + '/logout.php'} aria-label={strings.contact.logoutAria} title={strings.contact.logoutAria}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none"/>
                    <path d="M10 8l4 4-4 4" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="4" y1="12" x2="10" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
            </button>
            :
            <button className="icon"  onClick={() => setshowLoginAndRegistration(true)} aria-label={strings.contact.loginAria} title={strings.contact.loginAria}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none"/>
                  <circle cx="12" cy="9" r="3" fill="currentColor"/>
                  <path d="M6 18c0-2.5 3-4 6-4s6 1.5 6 4" fill="none" stroke="currentColor" stroke-width="2"/>
                </svg>
            </button>  
            }
           
            </div>
            
             
            {
          
            user ?
              <div className="user-profile">
              <img src={user.picture}  alt={user.name} />
              <br />
              {user.name}
              </div>
            :
              <div className="user-profile">
              <img src={no_user}  alt={strings.nav.nouser} />
              <br />
              {strings.nav.nouser}
              </div>
            }
      
           */}          
           </div>
        
          {/* 
          <div className="nav-lang" aria-label="Language selector">
           <button type="button" className="lang-btn" onClick={() => setLang('en')} aria-label={strings.lang.en_aria}>
            
              <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><clipPath id="s"><rect width="60" height="30"/></clipPath><g clip-path="url(#s)"><rect width="60" height="30" fill="#012169"/><path d="M0 0 L60 30 M60 0 L0 30" stroke="#fff" stroke-width="6"/><path d="M0 0 L60 30 M60 0 L0 30" stroke="#C8102E" stroke-width="4"/><path d="M30 0 L30 30 M0 15 L60 15" stroke="#fff" stroke-width="10"/><path d="M30 0 L30 30 M0 15 L60 15" stroke="#C8102E" stroke-width="6"/></g></svg>
              <span className="sr-only">{strings.lang.en_code}</span>
            </button>
            
            <button type="button" className="lang-btn" onClick={() => setLang('ru')} aria-label={strings.lang.ru_aria}>

              <svg viewBox="0 0 3 2" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect width="3" height="0.666" y="0.666" fill="#0039A6"/><rect width="3" height="0.666" y="1.333" fill="#D52B1E"/><rect width="3" height="0.666" y="0" fill="#FFFFFF"/></svg>
              <span className="sr-only">{strings.lang.ru_code}</span>
            </button>
          </div>
            */}
        </div>
        {showContact && createPortal(
          <div className="image-modal-overlay" onClick={() => closeContact()}>
            <div className="image-modal-wrapper" onClick={(e) => e.stopPropagation()}>
              <div className="contact-modal" role="dialog" aria-modal="true">
                <button className="image-modal-close" onClick={() => closeContact()} aria-label="Close contact form">×</button>
                <h3>{strings.contactForm?.title ?? 'Contact'}</h3>
                {!sent ? (
                  <form className="contact-form" onSubmit={(e) => {
                    e.preventDefault();
                    setSending(true);
                    sendEmail(e);
                    setTimeout(() => {
                      setSending(false);
                      setSent(true);
                    }, 800);
                  }}>
                    <label className="sr-only" htmlFor="contact-name">Name</label>
                    <input id="user_name" name="user_name" ref={nameRef} value={name} onChange={(e) => setName(e.target.value)} placeholder={strings.contactForm?.namePlaceholder ?? 'Your name'} />
                     <label className="sr-only" htmlFor="contact-email">Email</label>
                    <input type="email" id="user_email" name="user_email" ref={emailRef} value={email} onChange={(e) => setEmail(e.target.value)} placeholder={strings.contactForm?.emailPlaceholder ?? 'Your email'} />
                    <label className="sr-only" htmlFor="contact-msg">Message</label>
                    <textarea id="message" name="message" value={message} onChange={(e) => setMessage(e.target.value)} placeholder={strings.contactForm?.messagePlaceholder ?? 'Your message'} />
                    <button type="submit" className="contact-send" disabled={sending}>{sending ? 'Sending...' : (strings.contactForm?.sendButton ?? 'Send message')}</button>
                  </form>
                ) : (
                  <div className="contact-sent">{strings.contactForm?.sentMessage ?? 'Thanks — your message has been sent.'}</div>
                )}
              </div>
            </div>
          </div>,
          document.body
        )}
         {showLoginAndRegistration && createPortal(
          <div className="image-modal-overlay" onClick={() => setshowLoginAndRegistration(false)}>
            <div className="image-modal-wrapper" onClick={(e) => e.stopPropagation()}>
              <div className="contact-modal" role="dialog" aria-modal="true">
                <button className="image-modal-close" onClick={() => setshowLoginAndRegistration(false)} aria-label="Close Login form">×</button> 
               {AuthSocialForm(strings)}   
              </div>
            </div>
          </div>,
          document.body
        )}
      </div>
    </header>
  );
}
